module.exports = __webpack_public_path__ + "static/media/JS_exercise--mockup.a24401c6.png";